<template>
<div class="chapter">
<div class="inner_page">
<p class="center"><a id="piv"></a> First Mariner Books edition 1998</p>
<p class="timebreak"> <br/></p>
<p class="center">Copyright © 1989 by Molly Gloss</p>
<p class="timebreak"> <br/></p>
<p class="center">All rights reserved</p>
<p class="timebreak"> <br/></p>
<p class="center">For information about permission to reproduce selections from this book, write to Permissions, Houghton Mifflin Harcourt Publishing Company, 215 Park Avenue South, New York, New York 10003.</p>
<p class="timebreak"> <br/></p>
<p class="center"><a href="http://www.hmhco.com/popular-reading" target="_blank">www.hmhco.com</a></p>
<p class="timebreak"> <br/></p>
<p class="center"><em>The Library of Congress has cataloged the print edition as follows:</em><br/>
Gloss, Molly.<br/>
The jump-off creek / Molly Gloss,<br/>
p. cm.<br/>
<span style="font-size: smaller">ISBN</span> 0-395-51086-4<br/>
<span style="font-size: smaller">ISBN</span> 0-618-56587-6 (pbk.)<br/>
I. Title.<br/>
<span style="font-size: smaller">PS</span>3557.<span style="font-size: smaller">L</span>65<span style="font-size: smaller">J</span>8 1989<br/>
813'.54—dc20 89-32157 <span style="font-size: smaller">CIP</span></p>
<p class="timebreak"> <br/></p>
<p class="center">e<span style="font-size: smaller">ISBN</span> 978-0-547-52536-5<br/>
v1.0414</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// front01.vue?9eb33248